import React from "react";
import { StyledCustomizedRadio } from "./style";

type CustomizedRadioProps = {
  checked?: boolean;
  onChange?: () => void;
  name?: string;
  value?: string;
  disabled?: boolean;
  className?: string;
  defaultChecked?: boolean;
};

export const CustomizedRadio: React.FC<CustomizedRadioProps> = ({
  checked = false,
  onChange,
  disabled,
  className,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange();
    }
  };

  return (
    <StyledCustomizedRadio
      role="radio"
      aria-checked={checked}
      checked={checked}
      disabled={disabled}
      className={className}
      onClick={handleClick}
    />
  );
};